import { getRequest } from '@/framework/utils/request';
import { RequestGet } from '@/utils';
import qs from "qs";

const req = getRequest('common');

// 获取用户菜单
export function getUserMenus(data) {
  return req({
    url: '/usercenter/file/upload',
    method: 'post',
    data: data
  });
}

// 获取字典
export function getDictList(data) {
  return req({
    url: '/portal/portal/system/dict/selectDictList',
    method: 'post',
    data: data
  });
}
// 上传附件
export function uploadFile(data, fileParams) {
  return req({
    url: '/portal/system/upload',
    method: 'post',
    data: data,
    fileParams
  });
}
// 获取币种
export function customPage() {
  return req({
    url: '/portal/currency/custom-page',
    method: 'post',
    data: { pageSize: 10000 }
  });
}
// 开户银行
/**
 * @param { String } branchName 银行名称
 * @param { String } page 页码
 * @param { String } size 页数
 * @returns { Array } data 返回银行的数据
*/
export function bankList(params) {
  return req({
    url: '/portal/currency/bank/list',
    method: 'post',
    data: params
  });
}
// 保存供应商基本信息
export function saveSupplierInfo(data) {
  return req({
    url: '/portal/supplierInfo/saveSupplierInfo',
    method: 'post',
    data: data
  });
}
// 保存供应商基本信息
export function submitSupplierInfo(data) {
  return req({
    url: '/portal/supplierInfo/submitSupplierInfo',
    method: 'post',
    data: data
  });
}
// 供应商信息回显 /portal/supplierInfo/querySupplierInfoById
export function querySupplierInfoById(data) {
  return req({
    url: '/portal/supplierInfo/querySupplierInfoById',
    method: 'post',
    data: data
  });
}
// 后端加强版
export function querySupplierInfoByIdStrong(data) {
  return req({
    url: '/portal/supplierInfo/querySupplierInfoByIdNew',
    method: 'post',
    data: data
  });
}
// 删除供应商联系人
export function deletePesion(data) {
  return req({
    url: `/portal/supplierInfo/deletePersion/${data}`,
    method: 'post',
  });
}
// 删除供应商银行信息
export function delBankById(data) {
  return req({
    url: `/portal/supplierInfo/delBankById/${data}`,
    method: 'post',
  });
}
// 删除供应商品类
export function delCategoryById(data) {
  return req({
    url: `/portal/supplierInfo/delCategoryById/${data}`,
    method: 'post',
  });
}
// 删除供应商资质信息
export function delQualificationById(data) {
  return req({
    url: `/portal/supplierInfo/delQualificationById/${data}`,
    method: 'post',
  });
}
// 删除供应商地址
export function deleteFactory(data) {
  return req({
    url: `/portal/supplierInfo/deleteFactory`,
    method: 'post',
    data
  });
}
// 获取品类接口
export function getTree() {
  return req({
    url: `/portal/system/category/tree`,
    method: 'post',
    data: {}
  });
}

// 查询资质接口
export function searchZi(data) {
  return req({
    url: `/portal/supplierInfo/selAdmission`,
    method: 'post',
    data: data
  });
}
// 获取模板文件
export function getDomeId(params) {
  return req({
    url: `/portal/system/file`,
    method: 'get',
    params: params,
  });
}
// 下载文件
export function downloadFile(fileId) {
  return req({
    url: `/portal/system/file/${fileId}`,
    method: 'get',
    responseType: "blob",
  });
}
// 批量获取最新外网url
export function getWaiUrl(fileId) {
  return req({
    url: `/portal/system/previewFile?fileId=${fileId}`,
    method: 'get',
    fileId,
  });
}

// 下载文件
export function downloadFileById(id) {
  return req({
    url: '/portal/file/' + id,
    method: 'get',
    responseType: 'blob'
  })
}

// 首页-服务中心-修改密码 修改密码接口
export function resetPwd(data) {
  return req({
    url: '/portal/supplier/resetPwd',
    method: 'post',
    data
  })
}

// 登录后的 修改密码接口
export function updatePwd(data) {
  return req({
    url: '/portal/supplier/updatePwd',
    method: 'post',
    data
  })
}

// 首页-服务中心-更改手机号 更改手机号接口
export function updateSupplierPhone(data) {
  return req({
    url: `/portal/supplier/register/updateSupplierPhone`,
    method: 'post',
    data
  })
}

// 公告-分页列表查询
export function sourceNoticeList(data) {
  return req({
    url: `/portal/newBidBiddingNotify/supplierNotifyList`,
    method: 'post',
    data,
  })
}

// 中标公告-分页列表查询
export function sourceNoticeBidList(data) {
  return req({
    url: `/portal/bidNotice/bid/list`,
    method: 'post',
    data,
  })
}

// 公告-通过id查询
export function sourceNoticeGetById(params) {
  return req({
    url: `/portal/sourceNotice/getById`,
    method: 'get',
    params,
  })
}

// 招标公告-通过biddingNo查询
export function getByBiddingNo(params) {
  return req({
    url: `/portal/bidNotice/getByBiddingNo`,
    method: 'get',
    params,
  })
}

//招标公告-详情
export function getSupplierNotifyDetails(params) {
  return req({
    url: `/portal/newBidBiddingNotify/getSupplierNotify`,
    method: 'post',
    data:params
  })
}

// 中标公告-通过biddingNo查询
export function getBidByBiddingNo(params) {
  return req({
    url: `/portal/bidNotice/bid/getByBiddingNo`,
    method: 'get',
    params,
  })
}

// 判断是否已报名
export function getIsDuplicateSign(params) {
  return req({
    url: `/portal/sourceSign/getIsDuplicateSign`,
    method: 'get',
    params,
  })
}


// 报名接口
export function sourceSign(data) {
  return req({
    url: `/portal/sourceSign/sign`,
    method: 'post',
    data,
  })
}

// 报名分页
export function sourceSignList(data) {
  return req({
    url: `/portal/newBidSupplierSign/page`,
    method: 'post',
    data,
  })
}

// 进入报名详情
export function sourceSignGetById(params,param) {
  return req({
    url: `/portal/newBidSupplierSign/${params.id}`,
    method: 'get',
    params:param,
  })
}

// 报名保存
export function sourceSignEdit(data) {
  return req({
    url: `/portal/sourceSign/edit`,
    method: 'post',
    data,
  })
}

// 报名提交
export function sourceSignSubmit(data) {
  return req({
    url: `/portal/sourceSign/submit`,
    method: 'post',
    data,
  })
}

// 我的绩效
export function evaluateAchievementsPage(data) {
  return req({
    url: `/portal/evaluateAchievements/page`,
    method: 'post',
    data,
  })
}
// 我的绩效详情
export function evaluateAchievementsDetail(params) {
  return req({
    url: `/portal/evaluateAchievements/detail`,
    method: 'get',
    params,
  })
}
// 我的报价
export function sourceList(data) {
  return req({
    url: `/portal/supplier/list`,
    method: 'post',
    data,
  })
}
// 查询询价单详情
export function getQueryPriceInfo(params) {
  return req({
    url: `/portal/supplier/queryPriceInfo`,
    method: 'get',
    params,
  })
}
// 寻源参与
export function supplierPartake(params) {
  return req({
    url: `/portal/supplier/partake`,
    method: 'get',
    params,
  })
}
// 寻源放弃
export function supplierGiveUp(params) {
  return req({
    url: `/portal/supplier/giveUp`,
    method: 'get',
    params,
  })
}

// 首页-服务中心-我的待办 查询
export function myAgentSearch(data) {
  return req({
    url: `/portal/message/pm/push/detail/page`,
    method: 'post',
    data
  })
}

// 首页-服务中心-我的待办 更新信息为已读
export function detailUpdate(data) {
  return req({
    url: `/portal/message/pm/push/detail/detailUpdate?detailId=${data}`,
    method: 'get',
  })
}

export async function getLogin(data) {
  return request({
    url: `/portal/login/loginByAccount`,
    method: 'post',
    data,
  })
}

// 所有物料接口
export async function materialList (data) {
  return req({
    url: `/supplier/material/getMaterialList`,
    method: 'post',
    data,
  })
}
// 首页-用户中心-我和订单 查询
export async function pickBailLineList(data) {
  return req({
    url: `/portal/contract/getPortalOrderList`,
    method: 'post',
    data,
  })
}
// 首页-用户中心-我的合同 查询
export async function searchAgreement(data) {
  // console.log('data', data)
  const arrFiled = ['expiryStartDate', 'expiryEndDate', 'sn', 'demandCompanyCode', 'materialCode', 'categoryCode', 'state', 'type']
  const fileObj = {
    expiryStartDate: 'expiryStartDate.between',
    expiryEndDate: 'expiryEndDate.between',
    sn: 'sn',
    demandCompanyCode: 'demandCompanyCode.in',
    materialCode: 'materialCode.in',
    categoryCode: 'categoryCode.in',
    state: 'state.in',
    type: 'type'
  }
  const changeData = params => {
    let str = ''
    arrFiled.forEach(ele => {
      if (params[ele]) {
        str += `&${fileObj[ele]}=${data[ele]}`
        if (ele === 'type' && params[ele] === '1') {
          str += `&typeCode.in=strategicAgreement`
        }
      }
    })
    return str
  }
  return req({
    url: `/portal/contract/pageContract?supplierCompanyCode.in=${data.supplierCompanyCode}&page=${data.page}&pageSize=${data.pageSize}${changeData(data)}`,
    method: 'get',
  })
}

// 首页-用户中心-我的合同 查询
export async function exportAgreement(data) {
  // console.log('data', data)
  const arrFiled = ['expiryStartDate', 'expiryEndDate', 'sn', 'demandCompanyCode', 'materialCode', 'categoryCode', 'state', 'type']
  const fileObj = {
    expiryStartDate: 'expiryStartDate.between',
    expiryEndDate: 'expiryEndDate.between',
    sn: 'sn',
    demandCompanyCode: 'demandCompanyCode.in',
    materialCode: 'materialCode.in',
    categoryCode: 'categoryCode.in',
    state: 'state.in',
    type: 'type'
  }
  const changeData = params => {
    let str = ''
    arrFiled.forEach(ele => {
      if (params[ele]) {
        str += `&${fileObj[ele]}=${data[ele]}`
        if (ele === 'type' && params[ele] === '1') {
          str += `&typeCode.in=strategicAgreement`
        }
      }
    })
    return str
  }
  return req({
    url: `/portal/contract/contractExport?supplierCompanyCode.in=${data.supplierCompanyCode}&${changeData(data)}`,
    method: 'get',
  })
}
// 首页-用户中心-我的合同 公司查询
export async function selectOrganization(data) {
  return req({
    url: `/portal/supplierInfo/selectOrganization`,
    method: 'post',
    data: data
  })
}

// 首页-用户中心-新建公司 个人信息查询
/**
 * @param {'用户id'}
* @returns  Object
*/
export function getUserInfo(id) {
  return req({
    url: `/portal/supplierInfo/selectByAccountId?accountId=${id}`,
    method: 'get',
    id
  })
}
// 询比价-报价单
export function queryPriceInfo(params) {
  return req({
    url: `/portal/supplier/getPartakeDetails`,
    method: 'get',
    params,
  })
}
// 询比价-根据id查询供应商报价单
export function getInquirySupplierQuotationById(params) {
  return req({
    url: `/portal/supplier/getInquirySupplierQuotationById`,
    method: 'get',
    params,
  })
}

// 询比价-保存（只用于招投标2.8）
export function supplierEdit(data) {
  return req({
    url: `/portal/supplier/edit`,
    method: 'post',
    data,
  })
}

// 询比价-保存（新2.8）
export function inquirySupplierQuotationUpdate(data) {
  return req({
    url: `/portal/supplier/inquirySupplierQuotationUpdate`,
    method: 'post',
    data,
  })
}



// 获取公开附件的接口
export function getOpenFilesByBizKey(params) {
  return req({
    url: `/portal/file/getOpenFilesByBizKey`,
    method: 'get',
    params,
  })
}

// 招投标-详情
export function sourcegetByBiddingNo(params) {
  return req({
    url: `/portal/source/bidding/getByBiddingNo`,
    method: 'get',
    params,
  })
}

// 招投标-报价单
export function supplierSubmit(data) {
  return req({
    url: `/portal/supplier/submit`,
    method: 'post',
    data,
  })
}

// 询比价-报价单（新2.8）
export function inquirySupplierQuotationSubmit(data) {
  return req({
    url: `/portal/supplier/inquirySupplierQuotationSubmit`,
    method: 'post',
    data,
  })
}

// 招投标-报价单-撤回
export function supplierCancel(params) {
  return req({
    url: `/portal/supplier/cancel`,
    method: 'get',
    params,
  })
}

// 获取货物质量标准详情
export function getMaterialIndex(params) {
  return req({
    url: `/portal/supplier/getMaterialIndex`,
    method: 'get',
    params,
  })
}

// 首页-个人中心-用户中心 查询变更记录
export function getRecordInfo(params) {
  return req({
    url: `/portal/supplierInfo/getModifyRecords`,
    method: 'post',
    data: params,
  })
}

// 供应商信息变更-新增 变更
export function supplierInfoUpdate(data) {
  return req({
    url: `/portal/supplierInfo/updateSupplier`,
    method: 'post',
    data: data
  });
}

// 供应商基础信息 获取资质信息
export function getQalification(data) {
  return req({
    url: `/portal/supplierInfo/getQualification`,
    method: 'post',
    data: data
  });
}

// 中标-分页列表查询
export function bidNoticeList(data) {
  return req({
    url: `/portal/bidNotice/bid/list`,
    method: 'post',
    data,
  })
}

// 查询招标单详情
export function getQueryBiddingInfo(params) {
  return req({
    url: `/portal/supplier/queryBiddingInfo`,
    method: 'get',
    params,
  })
}

// 寻源招标单参与
export function supplierPartakePrice(params) {
  return req({
    url: `/portal/supplier/partakePrice`,
    method: 'get',
    params,
  })
}

// 寻源招标单放弃
export function supplierAbandon(params) {
  return req({
    url: `/portal/supplier/abandon`,
    method: 'get',
    params,
  })
}


// 导入物流
export function importTransportQuotationDetailExcel(data) {
  return req({
    url: `/portal/supplier/importTransportQuotationDetailExcel`,
    method: 'post',
    data: data,
  });
}

// 导入物流
export function importTransportQuotationDetailExcelErr(data) {
  return req({
    url: `/portal/supplier/importTransportQuotationDetailExcel`,
    method: 'post',
    data: data,
    responseType: "blob",
  });
}
// 导入进出口
export function importQuotationDetailExcel(data) {
  return req({
    url: `/portal/supplier/importQuotationDetailExcel`,
    method: 'post',
    data: data,
  });
}

// 导入进出口
export function importQuotationDetailExcelerr(data) {
  return req({
    url: `/portal/supplier/importQuotationDetailExcel`,
    method: 'post',
    data: data,
    responseType: "blob",
  });
}

export function queryProvincesAndCities(data) {
  return req({
    url: `/portal/supplierInfo/findAllProvincesAndCities`,
    method: 'post',
    data
  });
}


export function querySysArea(data) {
  return req({
    url: `/portal/supplierInfo/querySysArea`,
    method: 'post',
    data
  });
}
export function queryAllProvincesAndCities(data) {
  return req({
    url: `/portal/supplierInfo/queryAllProvincesAndCities`,
    method: 'post',
    data
  });
}

// 根据模板code查询模板id
export function mdmTemplateFindList(data) {
  return req({
    url: `/portal/currency/mdmTemplate/findList`,
    method: 'post',
    data: data
  });
}

// 导入
export function supplierLogisticsImportExcelData(data) {
  return req({
    url: `/portal/baseSupplierLogisticsRoute/importExcelData`,
    method: 'post',
    data,
    responseType: "blob",
    fileParams: {}
  });
}


// 招标-报价单详情
export function getQueryBidPriceInfo(params) {
  return req({
    url: `/portal/supplier/queryBidPriceInfo`,
    method: 'get',
    params,
  })
}
// 首页-个人中心-用户中心 印章联系人 个人认证
/**
 * @param {
 *  email: "邮箱地址",
 *  idNumber: "证件号码",
 *  idType: "证件类型",
 *  mobile: "手机号码",
 *  name: "姓名",
 *  thirdPartyUserId: "", // 自定义用户唯一标识，作为签署账号唯一性字段个人证件号-时间戳格式
 *  supplierCode:"供应商编码"
* }
* @returns
*/
export function createByThirdPartyUserId(params) {
  return req({
    url: `/portal/supplierInfo/accounts/createByThirdPartyUserId`,
    method: 'post',
    data: params
  })
}

// 首页-个人中心-用户中心 印章联系人 个人认证 （法大大）
/**
 * @param {
*  email: "邮箱地址",
*  idNumber: "证件号码",
*  idType: "证件类型",
*  mobile: "手机号码",
*  name: "姓名",
*  thirdPartyUserId: "", // 自定义用户唯一标识，作为签署账号唯一性字段个人证件号-时间戳格式
*  supplierCode:"供应商编码"
* }
* @returns
*/
export function fadadaPersonalSign(params) {
 return req({
   url: `/portal/supplierInfo/fadadaPersonalSign`,
   method: 'post',
   data: params
 })
}

// 首页-个人中心-用户中心 印章联系人 企业认证
/**
 * @param {
*  creator: "", 不传
*  idNumber: "统一信用社会代码",
*  idType: "",  不传
*  mobile: "手机号码",
*  name: "供应商名称",
*  thirdPartyUserId: "", // 自定义用户唯一标识，作为签署账号唯一性字段个人证件号-时间戳格式
*  supplierCode:"供应商编码"
* }
* @returns
*/
export function enterpriseCertification(params) {
  return req({
    url: `/portal/supplierInfo/organizations/createByThirdPartyUserId`,
    method: 'post',
    data: params
  })
}

// 首页-个人中心-用户中心 印章联系人 企业认证 （法大大）
/**
 * @param {
*  adminName: '',姓名
*  creator: "", 不传
*  idNumber: "统一信用社会代码",
*  idType: "",  不传
*  mobile: "手机号码",
*  name: "供应商名称",
*  thirdPartyUserId: "", // 自定义用户唯一标识，作为签署账号唯一性字段个人证件号-时间戳格式
*  supplierCode:"供应商编码"
* }
* @returns
*/
export function fadadaCompanySign(params) {
  return req({
    url: `/portal/supplierInfo/fadadaCompanySign`,
    method: 'post',
    data: params
  })
}


export function getAccountAndOrganizationCertificationStatus(params) {
  return req({
    url: `/portal/supplierInfo/getAccountAndOrganizationCertificationStatus`,
    method: 'post',
    data: params
  })
}


// 法大大获取个人实名认证
/**
 * @param {
*  email: "邮箱地址",
*  idNumber: "证件号码",
*  idType: "证件类型",
*  mobile: "手机号码",
*  name: "姓名",
*  thirdPartyUserId: "", // 自定义用户唯一标识，作为签署账号唯一性字段个人证件号-时间戳格式
*  supplierCode:"供应商编码"
* }
* @returns
*/
export function fadadaGetPersonalSign(params) {
  return req({
    url: `/portal/supplierInfo/fadadaGetPersonalSign`,
    method: 'post',
    data: params
  })
}

// 法大大获取企业实名认证
/**
 * @param {
*  adminName: '',姓名
*  creator: "", 不传
*  idNumber: "统一信用社会代码",
*  idType: "",  不传
*  mobile: "手机号码",
*  name: "供应商名称",
*  thirdPartyUserId: "", // 自定义用户唯一标识，作为签署账号唯一性字段个人证件号-时间戳格式
*  supplierCode:"供应商编码"
* }
* @returns
*/
export function fadadaGetCompanySign(params) {
  return req({
    url: `/portal/supplierInfo/fadadaGetCompanySign`,
    method: 'post',
    data: params
  })
}


// 获取公司下拉值
export function apiGetSourcingMain(params) {
  return req({
    url: `/portal/supplier/getSourcingMain`,
    method: 'get',
    params,
  })
}

// 首页-用户中心  供应商模糊搜索带出基本信息
export function getCompanyInfo(keyword) {
  return req({
    url: `/portal/supplierInfo/getCompanyName?keyword=${keyword}`,
    method: 'get',
    keyword
  })
}
// 首页-用户中心  供应商模糊搜索带出详细地址
/**
 * @param { String } keyword 传公司注册号
 * @returns { Array } data 返回该公司的数据
*/
export function getAddressInfo(keyword) {
  return req({
    url: `/portal/supplierInfo/getSupplierInfoFromQXB?keyword=${keyword}`,
    method: 'get',
    keyword
  })
}

// 首页-用户中心-我的合同  获取公司数据
/**
 * @param { Number } page 页码
 * @param { Number } size 页数
 * @param { String } state 状态 固定 '5'
 * @param { String } supplierCode 当前供应商编码
 * @param { String } organizationName 公司名称
 * @returns { Array } data 返回该公司的数据
*/
export function getCompany(params) {
  return req({
    url: `/portal/supplierInfo/selectOrganization`,
    method: 'post',
    data: params
  })
}

// 首页-用户中心-我的合同  获取品类数据
/**
 * @param { Number } page 页码
 * @param { Number } size 页数
 * @param { String } state 状态 固定 '5'
 * @param { String } supplierCode 当前供应商编码
 * @param { String } supplyCategoryDesc 品类名称
 * @returns { Array } data 返回该公司的数据
*/
export function getCategory(params) {
  return req({
    url: `/portal/supplierInfo/selectCategory`,
    method: 'post',
    data: params
  })
}

// 首页-用户中心-我的合同  获取品类数据
/**
 * @param { Number } page 页码
 * @param { Number } size 页数
 * @param { String } state 状态 固定 '5'
 * @param { String } supplierCode 当前供应商编码
 * @param { String } categoryCode 品类名称
 * @param { String } materialName 物料名称
 * @returns { Array } data 返回该公司的数据
*/
export function getMaterial(params) {
  return req({
    url: `/portal/supplierInfo/selectMaterial`,
    method: 'post',
    data: params
  })
}

// 首页-用户中心  卡片有权限
/**
 * @param { Number } phone 手机号
 * @param { Number } supplierCode 供应商编码
 * @returns { Array } data 返回有权限的卡片code的数据
*/
export function cardAuthority(params) {
  return req({
    url: `/portal/user/Role/getPortalUserRole`,
    method: 'get',
    params
  })
}

// 获取登录人的供应商列表
/**
 * @param { String } userId 用户id
 * @returns { Array } data 返回供应商列表的数组
*/
export function getAllSupplier(params) {
  return req({
    url: `/portal/supplierAfterLogin/switchCompanyByAccount`,
    method: 'get',
    params
  })
}

// 发送报价单短信
export function apiCreateShortLink(data) {
  return req({
    url: `/portal/contract/createShortLink`,
    method: 'post',
    data
  })
}

// 查询供应商
export function qrySupplierList(data) {
  return req({
    url: `/portal/supplierRelatedPerson/qrySupplierList`,
    method: 'post',
    data
  })
}

// 关联记录列表查询
export function supplierFindList(data) {
  return req({
    url: `/portal/supplierRelatedPerson/findList`,
    method: 'post',
    data
  })
}

// 保存 新增或修改关联
export function saveOrModify(data) {
  return req({
    url: `/portal/supplierRelatedPerson/saveOrModify`,
    method: 'post',
    data
  })
}

// 提交 关联
export function submitRelated(data) {
  return req({
    url: `/portal/supplierRelatedPerson/submit`,
    method: 'post',
    data
  })
}

// 删除 关联
export function deleteRelated(id) {
  return req({
    url: `/portal/supplierRelatedPerson/delete/${id}`,
    method: 'delete'
  })
}

// 详情
export function getPersonDetail(requestNo) {
  return req({
    url: `/portal/supplierRelatedPerson/${requestNo}`,
    method: 'get'
  })
}

// 系统公告
export function queryNoticeList(params) {
  return req({
    url: `/portal/notice/queryList`,
    method: 'get',
    params
  })
}


// 系统公告
export function getNoticeDetail(params) {
  return req({
    url: `/portal/notice/getNoticeDetail`,
    method: 'get',
    params,
  })
}
/**
 * 合同影象
 * @param {*} params
 * @returns
 */
export function getFiles(params) {
  return req({
    url: `/portal/file/getSignFiles`,
    method: 'get',
    params
  })
}


// 获取供应商是否社保数据为空
export function isSupplierPaySocialSecurity(keyword) {
  return req({
    url: `/portal/supplierInfo/isSupplierPaySocialSecurity?keyword=${keyword}`,
    method: 'get',
    keyword
  });
}


// 获取供应商社保信息
export function getSocialSecurityByName(keyword) {
  return req({
    url: `/portal/supplierInfo/getSocialSecurityByName?keyword=${keyword}`,
    method: 'get',
    keyword
  });
}

//单据配置条件查询
export function queryDocConfig(data) {
  return req({
      url: `/portal/system/queryDocConfig`,
      method: 'post',
      data: data
  })
}
// 导出合同
export function contractExport(data) {
  return req({
    url: `/portal/contract/contractExport`,
    method: 'get',
    params: data,
  });
}

//供应商信息登记表-新增记录
export function registrationSave(data) {
  return req({
    url: `/portal/newBidSupplierSign/registration/save`,
    method: 'post',
    data: data
  })
}

//供应商信息登记表-删除记录
export function registrationDel(data) {
  return req({
    url: `/portal/newBidSupplierSign/registration/deleteBatch`,
    method: 'post',
    data: data
  })
}

//投标我的报名-报名所属材料保存
export function rewBidSupplierSignFileSave(data) {
  return req({
    url: `/portal/newBidSupplierSign/file/save`,
    method: 'post',
    data: data
  })
}

//投标我的报名-供应商登记表保存
export function rewBidSupplierSignRegistrationSave(data) {
  return req({
    url: `/portal/newBidSupplierSign/registration/save`,
    method: 'post',
    data: data
  })
}

//投标我的报名-供应商登记表列表查询
export function rewBidSupplierSignRegistrationPage(data) {
  return req({
    url: `/portal/newBidSupplierSign/registration/page`,
    method: 'post',
    data: data
  })
}

//投标我的报名-报名所需材料查询
export function rewBidSupplierSignFilePage(data) {
  return req({
    url: `/portal/newBidSupplierSign/file/page`,
    method: 'post',
    data: data
  })
}

//投标我的报名-供应商登记表导出
export function rewBidSupplierSignRegistrationExport(data) {
  return req({
    url: `/portal/newBidSupplierSign/registration/export/${data}`,
    method: 'get',
    responseType: "blob"
  });
}

//投标我的报名-供应商登记表导入
export function rewBidSupplierSignRegistrationImport(data,fileParams) {
  return req({
    url: `/portal/newBidSupplierSign/registration/import`,
    method: 'post',
    data,
    fileParams,
    responseType: "blob"
  });
}

//投标我的报名-报名所需材料批量下载附件
export function rewBidSupplierSignBatchDownloadAttachments(params) {
  return req({
    url: `/portal/newBidSupplierSign/file/batchDownloadAttachments`,
    method: 'get',
    params
  });
}

//投标我的报名-报名所需材料批量下载模板
export function rewBidSupplierSignBatchDownloadTemplates(params) {
  return req({
    url: `/portal/newBidSupplierSign/file/batchDownloadTemplates`,
    method: 'get',
    params
  });
}

//投标我的报名保存
export function newBidSupplierSignSave(data) {
  return req({
    url: `/portal/newBidSupplierSign/save`,
    method: 'post',
    data: data
  })
}

//投标我的报名提交
export function newBidSupplierSignSubmit(data) {
  return req({
    url: `/portal/newBidSupplierSign/submit`,
    method: 'post',
    data: data
  })
}

//我的投标-列表
export function newBidSupplierBidPage(data) {
  return req({
    url: `/portal/source/newBidSupplierBid/page`,
    method: 'post',
    data: data
  })
}

//公告详情报名按钮点击
export function newBidSupplierSignNewClick(params) {
  return req({
    url: `/portal/newBidSupplierSign/noticeSign`,
    method: 'get',
    params
  });
}

//招投标-我的投标分页查询
export function newBidSupplierBidList(data) {
  return req({
    url: `/portal/newBidSupplierBid/page`,
    method: 'post',
    data: data
  })
}

//招投标-我的投标详情
export function newBidSupplierBidDetails(id) {
  return req({
    url: `/portal/newBidSupplierBid/` + id,
    method: 'get',
  });
}

//招投标-我的投标-附件分页查询
export function newBidSupplierBidFilePage(data) {
  return req({
    url: `/portal/newBidSupplierBid/file/page`,
    method: 'post',
    md5Compare: true,
    data: data
  })
}

//招投标-我的投标详情-物流信息分页

//招投标-我的投标-附件保存
export function newBidSupplierBidFileSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/file/save`,
    method: 'post',
    data: data
  })
}

//招投标-我的投标-附件删除

export function newBidSupplierBidFileDel(params) {
  return req({
    url: `/portal/newBidSupplierBid/file/delete`,
    method: 'get',
    params
  })
}

//我的报名-附件下载-压缩包列表
export function newBidSupplierSignCompressFile(params) {
  return req({
    url: `/portal/newBidSupplierSign/file/downloadList`,
    method: 'get',
    params
  })
}

//我的投标-进出口-基本信息
export function newBidSupplierBidExportImportPage(data) {
  return req({
    url: `/portal/newBidSupplierBid/eximQuotation/page`,
    method: 'post',
    data: data
  })
}

//我的投标-物流-基本信息
export function newBidSupplierBidLogisticsPage(data) {
  return req({
    url: `/portal/newBidSupplierBid/logisticsQuotation/page`,
    method: 'post',
    data: data
  })
}

//我的投标-船运
export function newBidSupplierBidShipLogisticsPage(data) {
  return req({
    url: `/portal/newBidSupplierBid/shipLogisticsQuotation/page`,
    method: 'post',
    data: data
  })
}
//我的投标-油脂
export function newBidSupplierBidGreaseLogisticsPage(data) {
  return req({
    url: `/portal/newBidSupplierBid/greaseLogisticsQuotation/page`,
    method: 'post',
    data: data
  })
}
//我的投标-油脂
export function newBidSupplierBidContainerLogisticsPage(data) {
  return req({
    url: `/portal/newBidSupplierBid/containerLogisticsQuotation/page`,
    method: 'post',
    data: data
  })
}


//我的投标-进出口-导入
export function newBidSupplierBidEximQuotationImport(data,fileParams) {
  return req({
    url: `/portal/newBidSupplierBid/eximQuotation/import`,
    method: 'post',
    data: data,
    fileParams,
    responseType: "blob"
  })
}

//我的投标-物流-导入
export function newBidSupplierBidLogisticsQuotationImport(data,fileParams) {
  return req({
    url: `/portal/newBidSupplierBid/logisticsQuotation/import`,
    method: 'post',
    data: data,
    fileParams,
    responseType: "blob"
  })
}
export function newBidSupplierBidSupplierLogisticsImport(data,fileParams) {
  return req({
    url: `/portal/newBidSupplierBid/supplierLogistics/import`,
    method: 'post',
    data: data,
    fileParams,
    responseType: "blob"
  })
}
//我的投标-进出口-保存
export function newBidSupplierBidEximQuotationSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/eximQuotation/save`,
    method: 'post',
    data: data
  })
}

//我的投标-物流-保存
export function newBidSupplierBidLogisticsQuotationSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/logisticsQuotation/save`,
    method: 'post',
    data: data
  })
}
// 投标集装箱物流
export function newBidSupplierBidContainerLogisticsQuotationSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/containerLogisticsQuotation/save`,
    method: 'post',
    data: data
  })
}
// 投标油脂
export function newBidSupplierBidGreaseLogisticsQuotationSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/greaseLogisticsQuotation/save`,
    method: 'post',
    data: data
  })
}
// 投标船运
export function newBidSupplierBidShipLogisticsQuotationSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/shipLogisticsQuotation/save`,
    method: 'post',
    data: data
  })
}
//我的投标-进出口-导出
export function newBidSupplierBidEximQuotationExport(data,portName) {
  return req({
    url: `/portal/newBidSupplierBid/eximQuotation/export?supplierBidId=${data}&portName=${portName}`,
    method: 'get',
    responseType: "blob"
  });
}

//我的投标-物流-导出
export function newBidSupplierBidLogisticsQuotationExport(data) {
  return req({
    url: `/portal/newBidSupplierBid/logisticsQuotation/export`,
    method: 'post',
    responseType: "blob",
    data: data
  });
}
export function newBidSupplierBidSupplierLogisticsExport(data) {
  return req({
    url: `/portal/newBidSupplierBid/supplierLogistics/export`,
    method: 'post',
    responseType: "blob",
    data: data
  });
}

//我的投标-保存
export function newBidSupplierBidSave(data) {
  return req({
    url: `/portal/newBidSupplierBid/save`,
    method: 'post',
    data: data
  })
}
// 物流
//我的投标-提交前校验
export function newBidSupplierBidSubmitCheck(data) {
  return req({
    url: `/portal/newBidSupplierBid/submitCheck`,
    method: 'post',
    data: data
  })
}
//我的投标-提交
export function newBidSupplierBidSubmit(data) {
  return req({
    url: `/portal/newBidSupplierBid/submit`,
    method: 'post',
    data: data
  })
}

/**
 * 获取审核详情
 * @param {currentUserId, processInstanceId} params
 * @returns
 */
export async function getInstDetail(params) {
  return req({
    url: `/portal/approval/web/taskInfo/getInstDetail`,
    method: 'get',
    params,
  })
}

//招投标-我的投标-附件文件批量下载
export async function newBidSupplierBidFileBatchDownloadAttachments(params) {
  return req({
    url: `/portal/newBidSupplierBid/file/batchDownloadAttachments`,
    method: 'get',
    params,
  })
}

//招投标-我的投标-模版文件批量下载
export async function newBidSupplierBidFileBatchDownloadTemplates(params) {
  return req({
    url: `/portal/newBidSupplierBid/file/batchDownloadTemplates`,
    method: 'get',
    params,
  })
}

//我的投标-附件下载-压缩包列表
export function newBidSupplierBidCompressFile(params) {
  return req({
    url: `/portal/newBidSupplierBid/file/downloadList`,
    method: 'get',
    params
  })
}

//查询所有工厂
export function getValidAllOrg() {
  return req({
    url: `/portal/system/org/getValidAllOrg`,
    method: 'get',
  })
}


// 分页查询对账数据
export function queryPageSupplierReconciliation(data) {
  return req({
    url: `/portal/contract/queryPageSupplierReconciliation`,
    method: 'post',
    data,
  });
}

// 编辑对账记录（支持批量）
export function updateBatchReconciliation(data) {
  return req({
    url: '/portal/contract/updateBatchReconciliation',
    method: 'post',
    data
  })
}

// 供应商电脑端报价导出
export function exportDetails(data) {
  return req({
    url: `/portal/supplier/exportDetails`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 打印询证函
export function printInquiryLetter(data) {
  return req({
    url: '/portal/contract/printInquiryLetter',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}



// 批量获取文件
export function systemBatch(data) {
  return req({
    url: '/portal/system/batch',
    method: 'post',
    data
  })
}

// 上传回函文件
export async function batchUploadReplyFiles(data) {
  return req({
    url: `/portal/contract/batchUploadReplyFiles`,
    method: 'post',
    data,
  })
}

// 批量获取文件
export function deleteReplyFile(data) {
  return req({
    url: `/portal/contract/deleteReplyFile`,
    method: 'post',
    data
  })
}
// 供应商电脑端报价导入
export function importDetails({ file }) {
  return req({
    url: `/portal/supplier/importDetails`,
    method: 'post',
    responseType: 'blob',
    data: file,
    fileParams: {}
  })
}

// 批量获取文件
export function querySupplierLogisticsPageList(data) {
  return req({
    url: `/portal/baseSupplierLogisticsRoute/queryPageList`,
    method: 'post',
    data
  })
}

// 供应商物流可操作路线-导出
export function supplierLogisticsExportXls(data) {
  return req({
    url: `/portal/baseSupplierLogisticsRoute/exportXls`,
    method: 'post',
    responseType: 'blob',
    data
  });
}

// 修改企业管理员时检查是否可以修改
export function checkCanChange(params) {
  return req({
    url: `/portal/admin/fadadaSrmInfo/checkCanChange`,
    method: 'get',
    params
  });
}

// 修改【供应商公司名称】法大大电子签章平台的企业管理员
export function updateCompanyAdmin(data) {
  return req({
    url: `/portal/admin/fadadaSrmInfo/updateCompanyAdmin`,
    method: 'post',
    data
  });
}
export async function unitPageApi(data) {
  // let param = RequestGet(data)
  return req({
    url: `/portal/currency/unit/custom-page`,
    method: 'post',
    data
  })
}
